import { createModuleDescriptor } from '../../redux/module-descriptor';
import { createEntityDescriptor } from '../../redux/entity-descriptor';
import selectors from './selectors';

const client = createModuleDescriptor('client', {
  entities: [
    createEntityDescriptor('client', {
      data: {
        url: '/api/clients/${options.id}.json',
      },
    }),
    createEntityDescriptor('sepaAgreement', {
      list: {
        url: '/api/sepaagreements.json',
        defaultFilters: { limit: 100 },
      },
    }),
    createEntityDescriptor('parentCompany', {
      data: {
        url: '/api/clients/parent.json',
      },
    }),
  ],
  selectors,
});
export default client;
